import { OpenModalParams, PopupType } from '@nx-frontend/shared/types';

export const getTrialStartStoreInitialState = (): OpenModalParams => {
  return {
    isShown: true,
    showCloseButton: false,
    closeButtonSize: 24,
    isFullScreen: true,
    content: PopupType.PAYWALL,
    payload: {
      payloadType: PopupType.PAYWALL,
      mode: 'trialStart',
    },
    position: false,
    modalContainerStyles: 'bg-transparent',
    escapeToClose: false,
  };
};
